import { Badge } from '@/components/ui';
import { useI18n, useT } from '@/i18n';
import type { Instance } from '@/lib/api';

const INSTANCE_STATUS: Record<
  Instance['status'],
  { de: string; en: string; variant: 'success' | 'info' | 'warning' | 'danger' | 'neutral' }
> = {
  ACTIVE: { de: 'Aktiv', en: 'Active', variant: 'success' },
  PENDING: { de: 'Wird eingerichtet', en: 'Provisioning', variant: 'info' },
  SUSPENDED: { de: 'Ausgesetzt', en: 'Suspended', variant: 'warning' },
  ERROR: { de: 'Fehler', en: 'Error', variant: 'danger' },
  DELETING: { de: 'Wird gelöscht', en: 'Deleting', variant: 'neutral' },
  DELETED: { de: 'Papierkorb', en: 'Trash', variant: 'neutral' },
};

export function InstanceStatusBadge({ status }: { status: Instance['status'] }) {
  const { locale } = useI18n();
  const config = INSTANCE_STATUS[status] ?? INSTANCE_STATUS.PENDING;
  return (
    <Badge variant={config.variant} dot>
      {locale === 'en' ? config.en : config.de}
    </Badge>
  );
}

/** Online, wenn der letzte Handshake juenger als 180 Sekunden ist. */
export function PeerStatusBadge({ online, enabled }: { online: boolean; enabled: boolean }) {
  const t = useT();
  if (!enabled) {
    return (
      <Badge variant="neutral" dot>
        {t('peers.disabled')}
      </Badge>
    );
  }
  return online ? (
    <Badge variant="success">
      <span className="animate-live h-1.5 w-1.5 rounded-full bg-current" />
      {t('peers.online')}
    </Badge>
  ) : (
    <Badge variant="neutral" dot>
      {t('peers.offline')}
    </Badge>
  );
}
